const CONFIG = {
  adminEmails: 'Admin E-Mails (comma seperated)',
  order_number: 'Order Number',
  request_number: 'Request Number',
  order_prefix: 'Order Prefix',
  request_prefix: 'Request Prefix',
};

export default CONFIG;
